<template>
  <div class="history-item">
    <div class="left" v-if="dataItem.date">
      <p class="date">{{ getTime(dataItem.date, "DD/MM/YYYY") }}</p>
      <p class="time">{{ getTime(dataItem.date, "HH:mm") }}</p>
    </div>
    <div class="right">
      <p class="name" v-if="dataItem.transactionUser">
        <span v-if="dataItem.packageNo">
          <strong>Paket No:</strong>
          {{ dataItem.packageNo }} -
        </span>
        <span v-else> Masraf Ödeme Durumu Değişikliği - </span>

        <strong>Değişikliği Yapan:</strong>
        {{ dataItem.transactionUser }}
      </p>
      <div class="sub-table-area">
        <p class="row" :key="item.id" v-for="item in dataItem.changes">
          <span
            class="status"
            :class="{
              add: item.changeStatus.key == 1,
              remove: item.changeStatus.key == 2,
            }"
            >{{ item.changeStatus.value }}:&nbsp;</span
          >
          <span class="text">
            <span v-if="item.name">{{ setEmptySpace(item.name) }} </span>
            <span v-if="item.algorithmFeature && item.algorithmFeature.name"
              >- {{ item.algorithmFeature.name }}</span
            >
            <span v-if="item.terminalNumber"
              >- Terminal No({{ item.terminalNumber }})</span
            >
          </span>
          <span class="when" v-if="item.dateSelection == '0'">(Hemen)</span>
          <span class="when" v-else-if="item.dateSelection == '1'"
            >(Gelecek Ay)</span
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataHsitoryItem",
  props: {
    dataItem: Object,
  },
  methods: {
    getTime(dateTime, formatType) {
      let stringDateTime = dateTime.toLocaleString();
      let generateMomentDate = this.$moment(new Date(stringDateTime)).format(
        formatType
      );
      return generateMomentDate;
    },
    setEmptySpace(text) {
      const emptyBeforeText = text.replace("(", " (");
      return emptyBeforeText;
    },
  },
};
</script>

<style lang="scss" scoped>
.history-item {
  border-top: 1px solid var(--grayscale-20);
  display: flex;
  align-items: center;
  &:nth-child(odd) {
    background-color: var(--grayscale-10);
    .sub-table-area {
      .row {
        &:nth-child(even) {
          background-color: #f9f9f9;
        }
        &:nth-child(odd) {
          background-color: var(--grayscale-0);
        }
      }
    }
  }
  .left {
    width: 140px;
    padding: 10px;
    text-align: center;
    .date {
      margin-bottom: 8px;
    }
  }

  .right {
    border-left: 1px solid var(--grayscale-20);
    padding: 30px;
    width: 100%;
    .name {
      color: #242424;
    }
  }

  .sub-table-area {
    width: 80%;
    margin-top: 1em;
    border: 1px solid var(--grayscale-20);
    border-radius: var(--radius-second);
    @media (max-width: 1025px) {
      width: 100%;
    }
    .text {
      line-height: 18px;
    }
    .row {
      padding: 14px 20px;

      &:nth-child(odd) {
        background-color: #f9f9f9;
      }
      &:nth-child(even) {
        background-color: var(--grayscale-0);
      }
      .status {
        font-weight: bold;
        &.add {
          color: var(--color-primary-default);
        }
        &.remove {
          color: var(--color-warning);
        }
      }
      .when {
        color: var(--grayscale-50);
      }
    }
  }
}
</style>
